import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { resendSignupToken, verifySignup } from "../../util/http";
import ReusableVerify from "./ReusableVerify";
import { setWithExpiry } from "../../util/util";

export default function VerifySignup({
  message,
  setMessage,
  setShow,
  setShow1,
  setLoading,
  loading,
  progress,
  setProgress,
}) {
  const [num1, setNum1] = useState("");
  const [num2, setNum2] = useState("");
  const [num3, setNum3] = useState("");
  const [num4, setNum4] = useState("");
  const [num5, setNum5] = useState("");
  const [num6, setNum6] = useState("");

  const [countDown, setCountdown] = useState(60);

  const [valid, setValid] = useState(true);

  useEffect(() => {
    const timer = setInterval(() => {
      if (countDown === 0) {
        setValid(true);
        clearInterval(timer);
        return;
      }
      setValid(false);
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [setCountdown, countDown]);

  const navigate = useNavigate();

  async function verificationHandler(e) {
    e.preventDefault();
    const token = `${num1}${num2}${num3}${num4}${num5}${num6}`;
    const data = {
      token: +token,
      type: "REGISTER",
    };
    try {
      setLoading(true);
      setProgress(20);
      setProgress(40);
      setProgress(60);
      const response = await verifySignup(data);
      setProgress(80);
      setProgress(100);
      setWithExpiry("token", response.data.token, 86400000);

      setLoading(false);
      setMessage({
        status: "success",
        text: response.message || "email verification successful",
      });
      setShow(true);
      setTimeout(() => setShow(false), 5000);
      navigate("/onboarding");
    } catch (error) {
      setProgress(100);
      setLoading(false);
      setMessage({
        status: "error",
        text: error.response.data.message || "something went wrong",
      });
      setShow(true);
      setTimeout(() => setShow(false), 2500);
    }
  }

  async function resendToken(e) {
    e.preventDefault();
    const email = localStorage.getItem("register_email");
    const data = {
      email,
      type: "REGISTER",
    };
    try {
      setLoading(true);
      await resendSignupToken(data);
      // setCountdown(300);
      setLoading(false);
      setMessage({
        status: "success",
        text: "Your verification token has been sent to your email",
      });
      setShow(true);
      setTimeout(() => setShow(false), 5000);
      setShow1(false);
    } catch (error) {
      setLoading(false);
      setMessage({
        status: "error",
        text: error.response.data.message || "something went wrong",
      });
      setShow(true);
      setTimeout(() => setShow(false), 5000);
    }
  }

  function fn(fro, to) {
    const inputField = document.getElementById(fro);
    const len = inputField.value.length;
    const max = inputField.getAttribute("maxlength");
    if (+len === +max) {
      return document.getElementById(to).focus();
    }
  }

  function deleteInput(e, fro, to) {
    if (e.key === "Backspace") {
      document.getElementById(fro).value = "";
      document.getElementById(fro).blur();

      if (fro === "inp6") {
        setNum6("");
      }
      return document.getElementById(to).focus();
    } else {
      return;
    }
  }

  return (
    <ReusableVerify
      message={message}
      setShow={setShow}
      setShow1={setShow1}
      loading={loading}
      onSubmit={verificationHandler}
      focusInput={fn}
      deleteInput={deleteInput}
      setCountdown={setCountdown}
      countDown={countDown}
      resendToken={resendToken}
      num1={num1}
      num2={num2}
      num3={num3}
      num4={num4}
      num5={num5}
      num6={num6}
      setNum1={setNum1}
      setNum2={setNum2}
      setNum3={setNum3}
      setNum4={setNum4}
      setNum5={setNum5}
      setNum6={setNum6}
      // timerId={timerId}
      valid={valid}
    />
  );
}
